import { configureStore, PreloadedState } from '@reduxjs/toolkit';
import { routerMiddleware } from 'connected-react-router';
import { History, LocationState } from 'history';
import { articleApi } from '../../features/article/api/articleApi';
import { categoryApi } from '../../features/category/api/categoryApi';

import { authApi } from '../auth/api/authApi';
import { rootMiddleware } from './rootMiddleware';
import { rootReducer } from './rootReducer';

export const createStore = (history: History<LocationState>, preloadedState?: PreloadedState<AppState>) => {
  return configureStore({
    reducer: rootReducer(history),
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(
        authApi.middleware,
        categoryApi.middleware,
        articleApi.middleware,
        routerMiddleware(history),
        rootMiddleware(history),
      ),
    preloadedState,
  });
};

export const rootStore = (history: History<LocationState>) => createStore(history);

export type AppState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof createStore>;
export type AppDispatch = AppStore['dispatch'];
